export default function R_Line() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Line Component</h1>
      <p>This is the R_Line tutorial section.</p>
    </div>
  );
}
